module.exports = __webpack_public_path__ + "img/loading-spinner.cc2b861e.gif";